export default {"src":"/_next/static/media/plus-outline.bdab606a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};